"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ResourceSelector = function ResourceSelector(_ref) {
  var _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'Select Resource' : _ref$buttonText,
    field = _ref.field,
    form = _ref.form,
    label = _ref.label,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Select Resource' : _ref$title;
  var onSelect = function onSelect(selectedFile) {
    form.setFieldValue(field.name, selectedFile.id);
  };
  var renderAssetPicker = function renderAssetPicker(closeModal) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.AssetPicker, {
      globalFilter: "image",
      render: function render(_ref2) {
        var body = _ref2.body,
          selectedFile = _ref2.selectedFile;
        return /*#__PURE__*/_react["default"].createElement("div", null, body, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].buttonWrapper
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary",
          disabled: !selectedFile,
          onClick: function onClick() {
            onSelect(selectedFile);
            closeModal();
          }
        }, "Select file")));
      },
      initialSelectedFile: field.value
    });
  };
  var renderButton = function renderButton() {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default"
      }, buttonText),
      title: title,
      render: function render(_ref3) {
        var closeModal = _ref3.closeModal;
        return renderAssetPicker(closeModal);
      }
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].fieldSpacing
  }, /*#__PURE__*/_react["default"].createElement("label", null, label), renderButton());
};
var _default = ResourceSelector;
exports["default"] = _default;